interface Props {
  levelNo: number
  name: string
  addon?: React.ReactNode
}

export default function LevelInfo({ levelNo, name, addon = <></> }: Props): React.ReactElement {
  return (
    <div className="space-x-2 flex items-center">
      <div className="bg-orchid-dark w-7 h-7 rounded-full text-white font-semibold flex justify-center items-center">
        {levelNo}
      </div>
      <p className="font-semibold">{name}</p>
      {addon}
    </div>
  )
}
